import React, { useState } from 'react'
import { useReferenceSheet } from '../ReferenceSheetProvider'
import { Button } from '../../../lib/ui/button'
import { PlusIcon } from '@heroicons/react/24/outline'
import { EditorHeading, newKey } from '../../ResumeBuilder/Editor/common'
import ReferenceItem from './ReferenceItem'
import { EditorItemProvider } from './EditorItemProvider'
import { useTranslation } from '~/hooks/useTranslation'

const ReferenceEditor = () => {
  const { t } = useTranslation('ReferenceEditor')
  const { referenceSheetDocument, setReferenceSheetDocument } =
    useReferenceSheet()
  const references = referenceSheetDocument?.references || []
  const [activeIndex, setActiveIndex] = useState(-1)

  const addReference = () => {
    const newIndex = references.length
    const updatedReferences = [...references, {}]
    setActiveIndex(newIndex)

    setReferenceSheetDocument({
      ...referenceSheetDocument,
      references: updatedReferences,
    })
  }

  return (
    <div className="flex flex-col">
      <EditorHeading>{t('references')}</EditorHeading>
      <div className="pb-4 tracking-[0.024px]">
        {t('references_description')}
      </div>
      {references.map((ref, index) => {
        ref.key = ref.key || newKey()
        return (
          <div key={ref.key}>
            <EditorItemProvider
              sectionName="references"
              index={index}
              activeIndex={activeIndex}
              setActiveIndex={setActiveIndex}
              item={ref}
            >
              <ReferenceItem />
            </EditorItemProvider>
          </div>
        )
      })}
      <Button onClick={addReference} className="max-w-min">
        {t('add_reference')}
        <PlusIcon className="ml-2 w-5" />
      </Button>
    </div>
  )
}
export default ReferenceEditor
